export default __webpack_public_path__ + "static/media/home-trend-up.544d3873.svg";